// 组件
import createTable from '@/components/createTable'
import viewFrame from '@/components/viewFrame'
import customeTable from '@/components/customeTable'
import dialogEffect from '@/components/dialogEffect'
// 接口
import { getPackagesDetail, deletePackages } from '@/services/zoo-tickets.js'
import { getHistoryList } from '@/services/resource'
import Utils from '@/utils/Utils'

// 其他
import loading from '@/utils/loading.json'
import history from '@/common/data/jsonData'
import jsonData from './jsonData'
import { mixin } from '@/mixins/viewDiolog'

export default {
  mixins: [mixin],
  components: {
    createTable,
    viewFrame,
    customeTable,
    dialogEffect
  },
  data () {
    return {
      validateVisible: false,
      buttonObj: [],
      titleObject: {},
      custName: {},
      formData: {},
      modifyData: {},
      type: '',
      basicViewItem: jsonData.basicViewItem,
      third_party_information: jsonData.third_party_information,
      guide_and_policies: jsonData.guide_and_policies,
      historyTableItem: history.historyTableItem,
      tableDataViewItem: jsonData.tableDataViewItem,
      dialogData: [],
      batchData: [],
      dialogVisible: false,
      historyTableData: []
    }
  },
  created () {
    const _this = this
    _this.urlParams = _this.$route.params
  },
  computed: {
    topVisible () {
      return Utils.isNull(this.$route.params.ticket_package_id_eq)
    },
    language () {
      return this.$store.getters.language
    }
  },
  mounted () {
    const _this = this
    _this.init()
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = _this.$loading(loading) : _this.$store.state.app.loading.close()
    },
    // 初始化
    init () {
      const _this = this
      _this.setGlobalLoading(true)
      getPackagesDetail(_this.urlParams.id).then(res => {
        _this.setGlobalLoading(false)
        _this.custName = res.data.package
        Object.assign(this.titleObject, { title: this.$t('form.zoo.packageName') + ': ' + this.custName.ticket_type_name ? this.custName.ticket_type_name : '' })
      }).catch(() => _this.setGlobalLoading(false))
      //  获取历史操作
      getHistoryList({ item_type: 'Package', item_id: _this.urlParams.id }).then(res => {
        this.historyTableData = res.data.versions
      })
    },
    forwardToPage (data, name) {
      if (name === 'shop') {
        this.$router.push({
          name: 'shopsManagerDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    // 点击操作按钮
    async handleClick (type, data) {
      console.log('---handleClick--data--', data)
      if (type?.action === 'edit') {
        this.$router.push({
          name: this.topVisible ? 'ticketPackageEdit' : 'basicTicketPackageEdit',
          params: {
            id: this.$route.params.id,
            ticket_package_id_eq: this.$route.params.ticket_package_id_eq,
            disabled: this.$route.params.ticket_package_id_eq ? 'true' : 'false',
            ticketType: this.$route.params.ticketType
          }
        })
      }
      if (type?.action === 'destroy') {
        this.deleteClick(this.$route.params.id, deletePackages, this.topVisible ? 'ticketPackageList' : 'basicTicketPackageList')
      }
    },
    handleOrderItemsTableForwardToPage (data, name) {
      if (name === 'shop_item') {
        this.$router.push({
          name: 'goodsManagerProductDetail',
          params: {
            id: data.id
          }
        })
      } else if (name === 'shop_item_bundle') {
        this.$router.push({
          name: 'bundleDetail',
          params: {
            id: data.id
          }
        })
      }
    }
  }
}
